// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2ZDzN","content":"LoadingAlert_content__3Vix4"};